<template>
  <div id="lb_id" class="lb_box" @mouseenter="boxEnter" @mouseleave="boxLeave">
    <div class="lb_imgbox">
      <div class="lb_imgleft">
        <div
          class="lb_li"
          v-for="(item, index) in picArr"
          :key="index"
          v-lazy-container="{ selector: 'img' }"
          :style="{ opacity: index == ids ? 1 : 0, background: item.picColor }"
        >
          <div class="lb_li_content">
            <img v-show="index === 0" :data-src="require('@/assets/copyright.png')" alt="" class="hover__img">
            <div>{{ item.title }}</div>
            <template v-if="index == 0 || index == 1 || index == 2">
              <div class="second__div" style="font-size: 36px">{{ item.content }}</div>
            </template>
            <template v-else>
              <div class="second__div">{{ item.content }}</div>
            </template>
            <div v-if="item.content_eng">{{ item.content_eng }}</div>
          </div>
          <img style="width: 100%; height: 100%" :data-src="item.url" alt="" />
        </div>
      </div>
      <ul class="lb_point" v-show="picArr.length > 1">
        <li
          class="lb_olli"
          v-for="(item, index) in picArr"
          @click="liClick(index)"
          :style="{ 'background-color': index == ids ? '#0171bb' : '#fff' }"
          :key="index"
        ></li>
      </ul>

      <button
        id="lb_lbtn"
        v-show="picArr.length > 1"
        @click="leftClick()"
        class="lb_btn lb_btnl"
      >
        &lt;
      </button>
      <button
        id="lb_rbtn"
        v-show="picArr.length > 1"
        @click="rightClick()"
        class="lb_btn lb_btnr"
      >
        &gt;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "carousel",
  data() {
    return {
      ids: 0,
      picArr: [
        {
          url: require("../assets/home-slide-1.png"),
          title: "万物互联、思达百疆",
          content:
            "Connecting Thoughts",
        },
        {
          url: require("../assets/home-slide-2.png"),
          title: "扎根技术创新、践行场景落地、助推数字化转型",
          content:
            "Innovation Rooting, Business Enabling, Digital Transformation Boosting",
        },
        {
          url: require("../assets/home-slide-3.png"),
          title: "助力国家治理体系和治理能力建设",
          content:
            "Contributing to National System & Capacity for Governance",
        },
        {
          url: require("../assets/winOnePic.png"),
          title: "智慧园区专家",
          content:
            "五年深耕，专注为政企园区、产业园区，以及各类场站、仓储库房等场所空间提供一体化综合运营管理操作系统及解决方案",
          content_eng: 'With 5-year comprehensive experiences, we are committed to providing smart campus/warehouse operations & management platform (Yunjiang OS) and business solutions.'
        },
        {
          url: require("../assets/winTwoPic.png"),
          title: "“云将”系统",
          content:
            "智慧园区一体化综合管控操作系统",
          content_eng: 'Yunjiang OS, an integrated smart campus operations & management platform.'
        },
        // {
        //   url: require("../assets/winThreePic.png"),
        //   title: "政企园区",
        //   content:
        //     "为封闭、半封闭园区打造数字化、协同化、可视化、智慧化的管控平台",
        // },
        // {
        //   url: require("../assets/winFourPic.png"),
        //   title: "产业园区",
        //   content:
        //     "为产业园区提供综合管控、公共服务、营商助企、园区门户、运营中心等数字智慧化服务",
        // },
        // {
        //   url: require("../assets/winFivePic.png"),
        //   title: "“碳中和”园区",
        //   content:
        //     "践行“双碳”战略，为实现园区“碳中和”提供综合能源、能效管理解决方案",
        // },
      ],
      setTimeoutWin: null,
    };
  },
  mounted() {
    var that = this;
    this.setTimeoutWin = setInterval(function () {
      that.rightClick();
    }, 5000);
  },
  methods: {
    leftClick() {
      if (this.ids == 0) {
        this.ids = this.picArr.length - 1;
      } else {
        this.ids--;
      }
    },
    rightClick() {
      if (this.ids == this.picArr.length - 1) {
        this.ids = 0;
      } else {
        this.ids++;
      }
    },
    liClick(idx) {
      this.ids = idx;
    },
    boxEnter() {
      clearInterval(this.setTimeoutWin);
    },
    boxLeave() {
      var that = this;
      this.setTimeoutWin = setInterval(function () {
        that.rightClick();
      }, 3000);
    },
  },
  destroyed() {
    clearInterval(this.setTimeoutWin);
  },
};
</script>

<style scoped>
/* 轮播图 */
.lb_li_content {
  width: 1200px;
  height: 100%;
  position: absolute;
  color: #fff;
  font-size: 22px;
  text-align: left;
}

.hover__img {
  position: absolute;
  top: 50%;
  right: -30px;
  transform: translateY(-50%);
  width: 350px;
  height: auto;
  z-index: 1;
}
.lb_li_content > div:nth-of-type(1) {
  font-size: 57px;
  font-weight: bold;
  margin-top: 195px;
}
.lb_li_content > div:nth-of-type() {
  margin-top: 28px;
}
.img {
  width: 100%;
  height: 100%;
}
.lb_li >>> img {
  vertical-align: baseline;
}
.lb_box {
  width: 100%;
  height: 540px;
}
.lb_imgbox {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.lb_imgleft {
  width: 100%;
  text-align: center;
  font-size: 30px;
  height: 100%;
  position: relative;
  left: 0;
  animation: all 1s;
}
.lb_li {
  list-style: none;
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all 1s;
  margin: 0;
}

.lb_point {
  position: absolute;
  bottom: 15px;
  right: 30px;
  padding-left: 0;
}
.lb_olli {
  list-style: none;
  display: inline-block;
  width: 30px;
  height: 4px;
  background-color: #fff;
  margin-right: 10px;
  transition: all 0.4s;
  cursor: pointer;
}
.lb_btn {
  position: absolute;
  top: 40%;
  background: transparent;
  background-color: rgba(255, 255, 255, 0.3);
  border: none;
  width: 50px;
  height: 130px;
  color: #fff;
  font-size: 30px;
  z-index: 1;
}
button {
  padding: 0;
}
.lb_btn:hover {
  background-color: #0171bb81;
}
.lb_btnl {
  left: 0;
}
.lb_btnr {
  right: 0;
}
@media (max-width: 576px) {
  .lb_li_content{
    width: 100%;
    text-align: center;
  }

  .second__div {
    font-size: 12px !important;
  }
  .lb_li img {
    width: 300% !important;
  }
  .lb_li_content > div:nth-of-type(1){
    margin-top: 100px;
    font-size: 18px;
  }
    .lb_li_content > div:nth-of-type(2){
    margin-top: 0px;
    padding-left: 10%;
    padding-right: 10%;
  }
  .lb_box{
    height: 270px;
  }
  .lb_li_content{
    font-size: 12px;
  }
  .lb_btn{
    top: 30%;
    width: 25px;
    height: 95px;
  }
  .lb_point{
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/carousel.vue